document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.fc-trending');
  var trackWrap = document.getElementById('fc-trending-track-wrap');
  var track = document.getElementById('fc-trending-track');
  var prevBtn = document.getElementById('fc-trending-prev');
  var nextBtn = document.getElementById('fc-trending-next');

  if (!trackWrap || !track) return;

  if (section && 'IntersectionObserver' in window) {
    var bgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fc-bg-visible');
        } else {
          entry.target.classList.remove('fc-bg-visible');
        }
      });
    }, { threshold: 0, rootMargin: '-10% 0px -10% 0px' });

    bgObserver.observe(section);
  } else if (section) {
    section.classList.add('fc-bg-visible');
  }

  var cards = Array.prototype.slice.call(track.querySelectorAll('.fc-trending__card'));

  cards.forEach(function (card, index) {
    card.style.transitionDelay = (index * 70) + 'ms';
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.15 });

    cards.forEach(function (card) {
      observer.observe(card);
    });
  } else {
    cards.forEach(function (card) {
      card.classList.add('is-visible');
    });
  }

  function scrollAmount() {
    var card = track.querySelector('.fc-trending__card');
    if (!card) return 280;
    var style = window.getComputedStyle(track);
    var gap = parseInt(style.gap || 20, 10) || 20;
    return card.offsetWidth + gap;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      trackWrap.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      trackWrap.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' });
    });
  }

  var maxScale = 1.16;
  var influenceRadius = 260;
  var rafId = null;
  var lastMouseX = null;

  function applyMagnify() {
    rafId = null;
    if (lastMouseX === null) return;

    cards.forEach(function (card) {
      var imgWrap = card.querySelector('.fc-trending__img-wrap');
      if (!imgWrap) return;
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var distance = Math.abs(lastMouseX - cardCenter);

      var scale = 1;
      if (distance < influenceRadius) {
        var proximity = 1 - (distance / influenceRadius);
        scale = 1 + (maxScale - 1) * Math.pow(proximity, 1.6);
      }

      imgWrap.style.transform = 'scale(' + scale.toFixed(3) + ')';
    });
  }

  function onMouseMove(e) {
    lastMouseX = e.clientX;
    if (rafId === null) {
      rafId = requestAnimationFrame(applyMagnify);
    }
  }

  function resetMagnify() {
    lastMouseX = null;
    cards.forEach(function (card) {
      var imgWrap = card.querySelector('.fc-trending__img-wrap');
      if (imgWrap) imgWrap.style.transform = 'scale(1)';
    });
  }

  trackWrap.addEventListener('mousemove', onMouseMove);
  trackWrap.addEventListener('mouseleave', resetMagnify);
});